import sys from '@truckdown/jsclient';
import * as icons from '@truckdown/jsclient/icons';
import * as apis from '@truckdown/jsclient/apis';
import { defineComponent, ref, computed, onMounted, onUnmounted } from 'vue';

import { HoursOfOperationDisplayType, Listing } from '@truckdown/locations';
import { HoursOfOperationDisplayTypeModel } from '../Services/HoursOfOperationDisplayTypeModel';

sys.fontLibrary.add(icons.solid.faLock);
sys.fontLibrary.add(icons.solid.faShopLock);
sys.fontLibrary.add(icons.solid.faCircleExclamation);
sys.fontLibrary.add(icons.solid.faCircleCheck);


export default defineComponent({
    props: {
        listing: {
            type: Object as () => Listing,
            required: true
        }
    },
    setup: function (props, ctx) {
        let listing = props.listing as Listing;

        const showHours = ref<boolean>(listing.hours
            && listing.hours != null
            && listing.hours.type != HoursOfOperationDisplayType.Unknown);
        const hoursIcon = ref<string[]>([]);
        const hoursStyle = ref<string>('icon');
        const statusMessage = ref<string>();
        const hoursMessage = ref<string>(listing.hours?.message ?? '');

        if (showHours.value) {
            switch (listing.hours.type) {
                case HoursOfOperationDisplayType.Open:
                    hoursIcon.value = ['fas', 'circle-check'];
                    hoursStyle.value = 'icon open';
                    statusMessage.value = 'Open';
                    break;
                case HoursOfOperationDisplayType.AfterHours:
                    hoursIcon.value = ['fas', 'circle-exclamation'];
                    hoursStyle.value = 'icon afterhours';

                    if (listing.properties.mobileOnly || listing.properties.managedService) {
                        statusMessage.value = 'Emergency Services Only';
                    } else {
                        statusMessage.value = 'Road Service Only';
                    }
                    break;
                case HoursOfOperationDisplayType.Closed:
                    hoursIcon.value = ['fas', 'lock'];
                    hoursStyle.value = 'icon closed';
                    statusMessage.value = 'Closed';
                    break;
            }
        }

        return {
            showHours,
            hoursIcon,
            hoursStyle,
            statusMessage,
            hoursMessage
        };
    }
});